import React from "react";

function Final() {
    return (
        <section className="final-section section-padding">
            <h2>Boost your links today</h2>
            <button className="button">Get Started</button>
        </section>
    );
}

export default Final;
